/* eslint-disable max-classes-per-file */
import { Anskaffningsformer } from "~app/common/models/constants";
import { RuleValidationMessage } from "~app/common/services/cqs/models/rule-validation-message";

export class AnsvarigAnvandare {
    userName: string;
    name: string;
}

export class VKAvtalResponseDTO {
    id: number;
    benamning: string;
    avtalsnummer: string;
    anskaffningsform: string;
    ansvarigVirkeskopare?: AnsvarigAnvandare;
    ansvarigSaljare: AnsvarigAnvandare;
    guid: string;
    rowVersion: string;
    hasKontraktSkickatTillVacs: boolean;
    validationMessages: RuleValidationMessage[];
}

export class VKAvtalEditDTO {
    id?: number;
    benamning: string;
    avtalsnummer: string;
    anskaffningsform: string;
    ansvarigVirkeskopare: string;
    ansvarigSaljare: string;
    guid: string;
}

export class Avtal {
    id: number;
    benamning: string;
    avtalsnummer: string;
    ansvarigVirkeskopare: AnsvarigAnvandare;
    ansvarigSaljare: AnsvarigAnvandare;
    anskaffningsform: string;
    guid: string;
    rowVersion: string;
    hasKontraktSkickatTillVacs: boolean;
    validationMessages: RuleValidationMessage[];
    isFirstDefaultKontraktSkogsvard = false;

    constructor(dto: VKAvtalResponseDTO) {
        this.id = dto.id;
        this.benamning = dto.benamning;
        this.avtalsnummer = dto.avtalsnummer;
        this.guid = dto.guid;
        this.rowVersion = dto.rowVersion;
        this.anskaffningsform = dto.anskaffningsform;
        this.ansvarigVirkeskopare = dto.ansvarigVirkeskopare;
        this.ansvarigSaljare = dto.ansvarigSaljare;
        this.validationMessages = dto.validationMessages;
        this.hasKontraktSkickatTillVacs = dto.hasKontraktSkickatTillVacs;
    }

    get isCvk() {
        return this.anskaffningsform === Anskaffningsformer.CentralaVirkeskop;
    }
}
